import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import AlarmLevel from '@blade-sxp/task-management/components/alarm-level.vue';
import FrequencyAndThreshold from '@blade-sxp/task-management/components/frequency-threshold.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty, cloneDeep } from 'lodash';
import { postTask, updateTask, getTaskDetail } from '@blade-sxp/task-management/api/creat-task/index';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import ConfidenceBox from '@blade-sxp/task-management/components/confidence.vue';
import OpenTime from '@blade-sxp/task-management/components/open-time.vue';
import colors from '@/styles/color.scss';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
const Service = {
    postTask,
    updateTask,
    getTaskDetail,
};
let CrowdRetrograde = class CrowdRetrograde extends Vue {
    taskType = '';
    name = '';
    status = 'ENABLE';
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    alertInterval = 600;
    type = 'add';
    id = '';
    isError = false;
    isDetail = false;
    loading = true;
    level = 'CRITICAL';
    disableRight = false;
    isReady = false;
    idealList = [
        { type: this.$t('hatlessConfidence'), value: 66, codeType: 'hatlessConfidence' },
        { type: this.$t('notWearingUniformConfidence'), value: 66, codeType: 'notWearingUniformConfidence' },
        { type: this.$t('shirtlessConfidence'), value: 66, codeType: 'shirtlessConfidence' },
        { type: this.$t('notWearingMaskConfidence'), value: 66, codeType: 'notWearingMaskConfidence' },
        { type: this.$t('smokingConfidence'), value: 66, codeType: 'smokingConfidence' },
        { type: this.$t('playPhoneConfidence'), value: 66, codeType: 'playPhoneConfidence' },
        { type: this.$t('phoneCallConfidence'), value: 66, codeType: 'phoneCallConfidence' },
        { type: this.$t('touchFaceConfidence'), value: 66, codeType: 'touchFaceConfidence' },
        { type: this.$t('eatFoodConfidence'), value: 66, codeType: 'eatFoodConfidence' },
    ];
    animalsList = [
        { type: this.$t('mouseDetectConfidence'), value: 66, codeType: 'mouseDetectConfidence' },
        { type: this.$t('catDetectConfidence'), value: 66, codeType: 'catDetectConfidence' },
        { type: this.$t('dogDetectConfidence'), value: 66, codeType: 'dogDetectConfidence' },
    ];
    tableList = [{ type: this.$t('foodResidueConfidence'), value: 66, codeType: 'foodResidueConfidence' }];
    kitchenwareList = [{ type: this.$t('lidUncoverDetectConfidence'), value: 66, codeType: 'lidUncoverDetectConfidence' }];
    titleList = {
        leftTitle: this.$t('taskType'),
        rightTitle: this.$t('confidence'),
    };
    kitchenDetectThreshold = {};
    kitchenWareThreshold = {};
    pestDetectThreshold = {};
    tableDetectThreshold = {};
    personnelBehavior = true;
    animalsInsects = true;
    kitchenware = true;
    tableDetection = true;
    openTime = '300';
    minValue = 0;
    maxValue = 100000;
    remark = '';
    get formData() {
        const { personnelBehavior, animalsInsects, kitchenware, tableDetection, name, openTime, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, alertInterval, idealList, animalsList, kitchenwareList, tableList, } = this;
        return {
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
            alertInterval,
            idealList,
            animalsList,
            kitchenwareList,
            tableList,
            openTime,
            personnelBehavior,
            animalsInsects,
            kitchenware,
            tableDetection,
        };
    }
    init() {
        const { type, id, taskType } = this.$route.query;
        this.type = type;
        this.taskType = taskType;
        this.id = id;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    async validForm(val) {
        if (this.isDetail) {
            return;
        }
        if (!this.personnelBehavior && !this.animalsInsects && !this.kitchenware && !this.tableDetection) {
            this.disableRight = true;
            return;
        }
        if (!this.isReady) {
            this.disableRight = true;
            return;
        }
        for (let i = 1; i <= 5; i++) {
            if (this.$refs['ruleForm' + i]) {
                let res = await this.$refs['ruleForm' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        const res = val.idealList.find((item) => {
            return item.value === '';
        });
        if (res?.value === '') {
            this.disableRight = true;
            return;
        }
        const animalsList = val.animalsList.find((item) => {
            return item.value === '';
        });
        if (animalsList?.value === '') {
            this.disableRight = true;
            return;
        }
        const kitchenwareList = val.kitchenwareList.find((item) => {
            return item.value === '';
        });
        if (kitchenwareList?.value === '') {
            this.disableRight = true;
            return;
        }
        const tableList = val.tableList.find((item) => {
            return item.value === '';
        });
        if (tableList?.value === '') {
            this.disableRight = true;
            return;
        }
        this.disableRight = false;
    }
    mounted() {
        const taskType = this.$route.query.taskType;
        if (taskType) {
            this.taskType = taskType;
        }
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const countUnitEnum = 'PERCENT';
        this.idealList.map((item) => {
            this.kitchenDetectThreshold[`${item.codeType}`] = { countUnitEnum: countUnitEnum, value: item.value };
        });
        this.animalsList.map((item) => {
            this.pestDetectThreshold[`${item.codeType}`] = { countUnitEnum: countUnitEnum, value: item.value };
        });
        this.tableList.map((item) => {
            this.tableDetectThreshold[`${item.codeType}`] = { countUnitEnum: countUnitEnum, value: item.value };
        });
        this.kitchenwareList.map((item) => {
            this.kitchenWareThreshold[`${item.codeType}`] = { countUnitEnum: countUnitEnum, value: item.value };
        });
        const params = {
            remark: this.remark,
            taskName: this.name,
            taskStatus: taskStatus,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    enabledAlarmLevels: [this.level],
                    frequency: {
                        unit: 'SECOND',
                        value: this.alertInterval,
                    },
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : effectiveTimes,
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        kitchenBehaviorDetectThreshold: {
                            ...this.kitchenDetectThreshold,
                            enable: this.personnelBehavior,
                        },
                        kitchenWareThreshold: {
                            ...this.kitchenWareThreshold,
                            enable: this.kitchenware,
                            lidUncoverDetectTime: {
                                unit: 'SECOND',
                                value: this.openTime,
                            },
                        },
                        pestDetectThreshold: {
                            enable: this.animalsInsects,
                            ...this.pestDetectThreshold,
                        },
                        tableDetectThreshold: {
                            ...this.tableDetectThreshold,
                            enable: this.tableDetection,
                        },
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            Service.postTask(params).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            Service.updateTask({ taskId: this.id, ...params }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    fromDataDeviceConfig() {
        const config = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let requestMap = new Map();
        requestMap = cloneDeep(device);
        const incidentType = plotMap.get(this.taskType).incidentType;
        if (!isEmpty(requestMap) && !isEmpty(incidentType)) {
            requestMap.forEach((item) => {
                const { zoneId, deviceId, titleList } = item;
                let rawRoi = {
                    kitchenBehaviorDetectConfig: [],
                    kitchenWareDetectConfig: [],
                    pestDetectConfig: [],
                    tableDetectConfig: [],
                };
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'ROI') {
                            item.data.forEach((item) => {
                                const { vertices, id, options } = item;
                                const { fillStyle } = options?.normal;
                                vertices.shift();
                                const temporary = {
                                    rawRoi: {
                                        vertices,
                                        id: this.taskId(),
                                        name: id,
                                    },
                                };
                                if (fillStyle === colors.polygonStrokeStyle) {
                                    rawRoi.kitchenBehaviorDetectConfig.push(temporary);
                                }
                                if (fillStyle === colors.lineFillStyle) {
                                    rawRoi.tableDetectConfig.push(temporary);
                                }
                                if (fillStyle === colors.boardLevelMajorColor) {
                                    rawRoi.kitchenWareDetectConfig.push(temporary);
                                }
                                if (fillStyle === colors.colorDanger) {
                                    rawRoi.pestDetectConfig.push(temporary);
                                }
                            });
                        }
                    });
                }
                let data = {
                    kitchenBehaviorDetectConfig: {
                        roiMappings: rawRoi?.kitchenBehaviorDetectConfig,
                        kitchenBehaviorDetectConfig: {},
                    },
                    kitchenWareDetectConfig: {
                        kitchenWareThreshold: {},
                        roiMappings: rawRoi?.kitchenWareDetectConfig,
                    },
                    pestDetectConfig: {
                        pestDetectThreshold: {},
                        roiMappings: rawRoi?.pestDetectConfig,
                    },
                    tableDetectConfig: {
                        tableDetectThreshold: {},
                        roiMappings: rawRoi?.tableDetectConfig,
                    },
                    zoneId,
                    deviceId,
                    incidentType,
                    roiData: JSON.stringify(device.get(deviceId)),
                };
                config.push(data);
            });
        }
        return config;
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                customClass: 'task-confirm',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    getData() {
        Service.getTaskDetail(Number(this.id))
            .then(({ name, status, remark, alarmConfig: { thresholdConfigs, notifyConfig }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes, kitchenBehaviorDetectThreshold, tableDetectThreshold, kitchenWareThreshold, pestDetectThreshold, } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
                this.alertInterval = notifyConfig?.frequency?.value;
                this.level = notifyConfig?.enabledAlarmLevels[0];
                let arr = [];
                const arrData = cloneDeep(this.idealList);
                this.personnelBehavior = kitchenBehaviorDetectThreshold['enable'];
                arrData.forEach((item) => {
                    arr.push({
                        type: `${this.$t(item.codeType)}`,
                        value: kitchenBehaviorDetectThreshold[item.codeType].value,
                        codeType: item.codeType,
                    });
                });
                this.idealList = arr;
                let tableArr = [];
                const tableData = cloneDeep(this.tableList);
                this.tableDetection = tableDetectThreshold['enable'];
                tableData.forEach((item) => {
                    tableArr.push({
                        type: `${this.$t(item.codeType)}`,
                        value: tableDetectThreshold[item.codeType].value,
                        codeType: item.codeType,
                    });
                });
                this.tableList = tableArr;
                let kitchenArr = [];
                const kitData = cloneDeep(this.kitchenwareList);
                this.kitchenware = kitchenWareThreshold['enable'];
                this.openTime = kitchenWareThreshold['lidUncoverDetectTime'].value;
                kitData.forEach((item) => {
                    kitchenArr.push({
                        type: `${this.$t(item.codeType)}`,
                        value: kitchenWareThreshold[item.codeType].value,
                        codeType: item.codeType,
                    });
                });
                this.kitchenwareList = kitchenArr;
                let pestArr = [];
                const pestData = cloneDeep(this.animalsList);
                this.animalsInsects = pestDetectThreshold['enable'];
                pestData.forEach((item) => {
                    pestArr.push({
                        type: `${this.$t(item.codeType)}`,
                        value: pestDetectThreshold[item.codeType].value,
                        codeType: item.codeType,
                    });
                });
                this.animalsList = pestArr;
                if (!isEmpty(deviceTaskConfigs)) {
                    deviceTaskConfigs.forEach((item) => {
                        const roiData = item.roiData;
                        if (!isEmpty(roiData)) {
                            const analysis = JSON.parse(roiData);
                            DeviceIdDataModule.deviceIdRequestParams.set(analysis.id, analysis);
                        }
                    });
                }
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], CrowdRetrograde.prototype, "init", null);
__decorate([
    Watch('formData', { deep: true, immediate: true })
], CrowdRetrograde.prototype, "validForm", null);
CrowdRetrograde = __decorate([
    Component({
        name: 'CrowdRetrograde',
        components: {
            'st-device-darwer': DeviceDarwer,
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            'alarm-level': AlarmLevel,
            'frequency-and-threshold': FrequencyAndThreshold,
            'button-box': ButtonBox,
            'confidence-box': ConfidenceBox,
            'open-time': OpenTime,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    alert: 'Alert Notification',
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    tip: 'Title',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    hatlessConfidence: 'No Chef Hat',
                    notWearingUniformConfidence: 'No Uniform',
                    detection: 'Personnel Behavior',
                    confidence: 'Confidence',
                    taskType: 'Type',
                    shirtlessConfidence: 'Shirtless',
                    notWearingMaskConfidence: 'No Mask',
                    smokingConfidence: 'Smoke',
                    playPhoneConfidence: 'Play Phone',
                    phoneCallConfidence: 'Phone Call',
                    touchFaceConfidence: 'Touch Face',
                    eatFoodConfidence: 'Eat Food',
                    animalsInsects: 'Animals & Pest',
                    mouseDetectConfidence: 'Mouse',
                    catDetectConfidence: 'Cat',
                    dogDetectConfidence: 'Dog',
                    tableDetection: 'Table Detection',
                    foodResidueConfidence: 'Food Residue',
                    kitchenware: 'Kitchenware',
                    lidUncoverDetectConfidence: 'Open The Lid',
                    openTimeTitle: 'Lid Opening Time',
                },
                zh: {
                    alert: '告警通知',
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    hatlessConfidence: '未戴帽子',
                    notWearingUniformConfidence: '未穿厨师服',
                    detection: '人员行为种类',
                    confidence: '置信度',
                    taskType: '类型',
                    shirtlessConfidence: '未穿上衣',
                    notWearingMaskConfidence: '未戴口罩',
                    smokingConfidence: '吸烟',
                    playPhoneConfidence: '玩手机',
                    phoneCallConfidence: '打电话',
                    touchFaceConfidence: '摸口鼻',
                    eatFoodConfidence: '吃食物',
                    animalsInsects: '害虫检测',
                    mouseDetectConfidence: '老鼠',
                    catDetectConfidence: '猫',
                    dogDetectConfidence: '狗',
                    tableDetection: '餐桌检测',
                    foodResidueConfidence: '桌面食物残留',
                    kitchenware: '盒盖检测',
                    lidUncoverDetectConfidence: '盒盖打开',
                    openTimeTitle: '盖子打开时间阈值',
                },
            },
        },
    })
], CrowdRetrograde);
export default CrowdRetrograde;
